import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress, Typography } from '@mui/material';
import { Header, ProgressBarContainer } from './ProgressBar.css';
const ProgressBar = ({ currentValue, maxValue, height }) => {
    const percentage = maxValue
        ? Math.round((100 * (currentValue !== null && currentValue !== void 0 ? currentValue : 0)) / maxValue)
        : 0;
    return (_jsxs(Header, { children: [_jsx(ProgressBarContainer, { children: _jsx(LinearProgress, { value: percentage, variant: "determinate", sx: { height: height !== null && height !== void 0 ? height : '18px', borderRadius: '10px' } }) }), _jsx(Typography, Object.assign({ variant: "body2" }, { children: `${currentValue !== null && currentValue !== void 0 ? currentValue : 0}/${maxValue !== null && maxValue !== void 0 ? maxValue : 0}` }))] }));
};
export default ProgressBar;
